import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    state: {
        showFooter: true,
        view: '',
        title: '',
        customTitle: '',
        modalId: '',
        customClasses: '',
        customBodyClasses: '',
        showCloseButton: true,
        showCancelButton: true,
        cancelTextKey: 'main_container:modal_close',
        confirmationTextKey: 'main_container:modal_save',
        footerPrimaryButtonClasses: '',
        stopClickPropagationOnModalClick: false,
        modalIsOpen: false,
        onCloseClicked: null,
        onCancelClicked: null,
        onConfirmationClicked: null,
        customFooterTemplate: null,
        confirmationButtonDisabled: false
    }
};

const showModal = (state, action) => {
    return {
        ...INITIAL_STATE.state,
        ...action.data,
        modalIsOpen: true
    };
};

const hideModal = (state, action) => ({
    ...INITIAL_STATE.state,
    ...action.data
});

const enableConfirmationButton = (state, action) => ({
    ...state,
    confirmationButtonDisabled: false
});

const disableConfirmationButton = (state, action) => ({
    ...state,
    confirmationButtonDisabled: true
});

const handlers = {
    [types.SHOW_MODAL]: showModal,
    [types.HIDE_MODAL]: hideModal,
    [types.ENABLE_CONFIRMATION_BUTTON]: enableConfirmationButton,
    [types.DISABLE_CONFIRMATION_BUTTON]: disableConfirmationButton
};

export const getModalState = (state) => {
    return state.modalState;
};

export default function modalState(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
